import {
  GET_PRIZEPOOL_DETAIL_REQUEST,
  GET_PRIZEPOOL_DETAIL_REQUEST_SUCCESS,
  GET_PRIZEPOOL_DETAIL_REQUEST_FAILURE,
  GET_PRIZEPOOL_REQUEST,
  GET_PRIZEPOOL_REQUEST_SUCCESS,
  GET_PRIZEPOOL_REQUEST_FAILURE,
  GET_LUCKYDRAW_POOLS,
  GET_LUCKYDRAW_POOLS_SUCCESS,
  GET_LUCKYDRAW_POOLS_FAILURE,
  GET_LUCKYDRAW_WINNERS_FAILURE,
  GET_LUCKYDRAW_WINNERS_SUCCESS,
  GET_LUCKYDRAW_WINNERS,
  GET_LUCKYDRAW_CONFIG_SUCCESS,
  GET_LUCKYDRAW_CONFIG,
  GET_LUCKYDRAW_CONFIG_FAILURE,
  GET_LUCKYDRAW_POOLS_DETAILS,
  GET_LUCKYDRAW_POOLS_DETAILS_SUCCESS,
  GET_LUCKYDRAW_POOLS_DETAILS_FAILURE,
} from "../constants";

const initialState = {
  loader: false,
  games: [],
  pools: [],
  poolsDetails: [],
  winners: [],
  luckydraw: {},
  gameDetail: {},
};

export default function PrizePoolReducer(state = initialState, action) {
  switch (action.type) {
    case GET_PRIZEPOOL_REQUEST:
      state = {
        ...state,
        loader: true,
      };
      break;
    case GET_PRIZEPOOL_REQUEST_SUCCESS:
      state = {
        ...state,
        games: action.payload,
        loader: false,
      };
      break;
    case GET_PRIZEPOOL_REQUEST_FAILURE:
      state = {
        ...state,
        loader: false,
      };
      break;

    case GET_PRIZEPOOL_DETAIL_REQUEST:
      state = {
        ...state,
        loader: true,
      };
      break;
    case GET_PRIZEPOOL_DETAIL_REQUEST_SUCCESS:
      state = {
        ...state,
        gameDetail: action.payload,
        loader: false,
      };
      break;
    case GET_PRIZEPOOL_DETAIL_REQUEST_FAILURE:
      state = {
        ...state,
        loader: false,
      };
      break;

    case GET_LUCKYDRAW_CONFIG:
      state = {
        ...state,
        loader: true,
      };
      break;
    case GET_LUCKYDRAW_CONFIG_SUCCESS:
      state = {
        ...state,
        luckydraw: action.payload,
        loader: false,
      };
      break;
    case GET_LUCKYDRAW_CONFIG_FAILURE:
      state = {
        ...state,
        loader: false,
      };
      break;

    case GET_LUCKYDRAW_POOLS:
      state = {
        ...state,
        loader: true,
      };
      break;
    case GET_LUCKYDRAW_POOLS_SUCCESS:
      state = {
        ...state,
        pools: action.payload,
        loader: false,
      };
      break;
    case GET_LUCKYDRAW_POOLS_FAILURE:
      state = {
        ...state,
        loader: false,
      };
      break;

    case GET_LUCKYDRAW_POOLS_DETAILS:
      state = {
        ...state,
        loader: true,
      };
      break;
    case GET_LUCKYDRAW_POOLS_DETAILS_SUCCESS:
      state = {
        ...state,
        poolsDetails: action.payload,
        loader: false,
      };
      break;
    case GET_LUCKYDRAW_POOLS_DETAILS_FAILURE:
      state = {
        ...state,
        loader: false,
      };
      break;

    
    case GET_LUCKYDRAW_WINNERS:
      state = {
        ...state,
        loader: true,
      };
      break;
    case GET_LUCKYDRAW_WINNERS_SUCCESS:
      state = {
        ...state,
        winners: action.payload,
        loader: false,
      };
      break;
    case GET_LUCKYDRAW_WINNERS_FAILURE:
      state = {
        ...state,
        loader: false,
      };
      break;

    default:
      break;
  }

  return state;
}
